import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';
import AssetGroupDataProcessingDefinitionList from '../../../../modules/dataprocessingdefinitions/AssetGroupDataProcessingDefinitionList';
import editRoute from './edit/routes';

import IconCalculator from '../../../../assets/icon_data.svg?react';
import {AUTHORITY_READ_KPI_DATA_PROCESSING_DEFINITION} from '../../../../modules/common/consts';

export default {
	relativePath: 'dataprocessingdefinitions',
	label: {
		id: 'assets.detail.dataProcessingDefinition.title',
		defaultValue: 'KPI/Data Processing'
	},
	component: AssetGroupDataProcessingDefinitionList,
	iconSvg: IconCalculator,
	childRoutes: [editRoute],
	requiredAuthorities: [AUTHORITY_READ_KPI_DATA_PROCESSING_DEFINITION]
} satisfies RouteConfig;
